import React, { FC } from 'react';
import PropTypes from 'prop-types';
import ValcodeLogo from '../../src/assets/svg/logo3.svg';
interface ILogoProps {
	width?: number;
	height?: number;
}
const Logo: FC<ILogoProps> = ({ width, height }) => {
	return (
		<img src={ValcodeLogo} alt='Valcode Logo' style={{ width: '123px', height: '90px', gap: '0px', opacity: '0px' }} />

	);
};
Logo.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
};
Logo.defaultProps = {
	width: 2155,
	height: 854,
};

export default Logo;
